module.exports = __webpack_public_path__ + "media/images/landing-pages/pri-hero-d303eb925de3077bebf9d5a6cae4f9cc.png";